import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import Router from "./router";

import "./index.css";
import "./services/i18n";
import "react-toastify/dist/ReactToastify.css";
import {
  EVENT_MONITORING_TOKEN_KEY,
  EVENT_MONITORING_USER_ID_KEY,
  EVENT_MONITORING_USER_KEY,
} from "./utils/constants";

const msalInstance = new PublicClientApplication(msalConfig);
msalInstance
  .handleRedirectPromise()
  .then((tokenResponse) => {
    if (tokenResponse !== null) {
      localStorage.setItem(
        EVENT_MONITORING_TOKEN_KEY,
        tokenResponse.accessToken
      );
      localStorage.setItem(
        EVENT_MONITORING_USER_KEY,
        tokenResponse.account?.username || "undefined"
      );
      localStorage.setItem(
        EVENT_MONITORING_USER_ID_KEY,
        tokenResponse.account?.name || "undefined"
      );
      localStorage.setItem("auth-provider", "azure-sso");
    }
  })
  .catch((error) => {
    console.error(error);
  });

ReactDOM.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <Suspense fallback="loading...">
        <BrowserRouter>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          <Router />
        </BrowserRouter>
      </Suspense>
    </MsalProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
